// @flow

export const types = {
    CATALOG: 'CATALOG',
    FOLDERS: 'FOLDERS',
    ITEMS: 'ITEMS',
    PDP: 'PDP',
    INVOICE: 'INVOICE',
    DESIGN_PROFILE: 'DESIGN_PROFILE',
};

export type ModalTypes = $Keys<typeof types>;
export const typesRequiringName: ModalTypes[] = [
    types.CATALOG,
    types.FOLDERS,
    types.ITEMS,
    types.PDP,
    types.DESIGN_PROFILE,
];

export const mutations = {
    responses: {
        ERROR: 'error',
        COMPLETE: 'complete',
        LOADING: 'loading',
        NULL: 'nullState',
        SUCCESS: 'success',
    },
    types: {
        SHARE: 'SHARE',
    },
};

export type MutationResponses = 'error' | 'complete' | 'loading' | 'nullState' | 'success';

export const slugify = (portfolioName: string = '', portfolioId: string = ''): string => {
    // Only allow dashes and alphanumeric characters in url label
    const folderType = types.FOLDERS.toLowerCase();
    const portName = portfolioName
        .trim()
        .toLowerCase()
        .replace(/[^\w]+/gi, '-')
        .replace(/^-+/, '')
        .replace(/-+$/, '');
    if (portName) {
        return `/${folderType}/${portName}/${portfolioId}/`;
    }

    return `/${folderType}/${portfolioId}/`;
};

export const getFolderLink = (portfolioName: string = '', portfolioId: string = ''): string => {
    return `${
        typeof location !== 'undefined' ? location.origin : 'https://www.1stdibs.com'
    }/favorites${slugify(portfolioName, portfolioId)}`;
};

export const getInvoiceLink = (
    transactionId: string = '',
    invoiceAccessToken: string = ''
): string =>
    `${
        typeof location !== 'undefined' ? location.origin : 'https://www.1stdibs.com'
    }/my/orders/invoice/share/${transactionId}?shareToken=${invoiceAccessToken}`;
